import React, { useState, useEffect } from "react"
import { CalendarTodayOutlined, Search } from "@mui/icons-material"
import { InputWithIcon } from "shared/ui/input/InputWithIcon"
import FilterAltOffOutlinedIcon from "@mui/icons-material/FilterAltOffOutlined"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import { TableFallback } from "widgets/fallbacks/TableFallback"
import { useGetTransactionsQuery, useGetBalanceQuery } from "./transactionApi"
import { TransactionTable } from "../../entities/transaction/TransactionTable"
import BalanceModal from "../../shared/ui/modals/BalanceModal"
import { Period } from "../../entities/bookings/ui/forms/Period.jsx"
import EmptyState from "widgets/fallbacks/EmptyState"

function formatDate(date) {
  if (!date) return ""
  const d = new Date(date)
  const year = d.getFullYear()
  const month = (d.getMonth() + 1).toString().padStart(2, "0")
  const day = d.getDate().toString().padStart(2, "0")
  return `${day}.${month}.${year}`
}

const Transactions = () => {
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [search, setSearch] = useState("")
  const [value, setValue] = useState("")
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [currentPage, setCurrentPage] = useState(1)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [showPeriod, setShowPeriod] = useState(false)
  const {
    data: transactionsData,
    isLoading,
    refetch: refetchTransactions,
  } = useGetTransactionsQuery({
    startDate: startDate ? formatDate(startDate) : undefined,
    endDate: endDate ? formatDate(endDate) : undefined,
    search,
    perPage: rowsPerPage,
    page: currentPage,
  })

  const { data: balanceData } = useGetBalanceQuery()
  //   undefined, {
  //   selectFromResult: ({ data }) => ({ data }),
  // }

  // Автоматическое обновление при изменении фильтров
  useEffect(() => {
    refetchTransactions()
  }, [
    startDate,
    endDate,
    search,
    rowsPerPage,
    currentPage,
    refetchTransactions,
  ])

  // Обработчик изменения страницы
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage)
  }

  // Обработчик изменения количества строк на странице
  const handleRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage)
    setCurrentPage(1) // Сбрасываем на первую страницу при изменении количества строк
  }

  const onChangeInput = (event) => {
    setValue(event.target.value)
    setSearch(event.target.value)
  }

  const clearFilters = () => {
    setSearch("")
    setValue("")
    setStartDate(null)
    setEndDate(null)
  }

  const togglePeriod = () => {
    setShowPeriod((prev) => !prev)
  }

  const handleOpenModal = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  return (
    <div className='sm:rounded-lg     sm:px-0 '>
      <div className='flex bg-white sm:bg-transparent  gap-4 flex-row justify-between'>
        <div className='sm:hidden  w-full px-4 sticky top-16  py-4 flex  gap-0 '>
          <button
            className='flex p-3 max-w-[48px] w-full rounded-[6px] items-center justify-center border border-[#EDEDED] mr-4'
            onClick={togglePeriod}
          >
            <CalendarTodayOutlined color={"disabled"} />
          </button>
          {showPeriod && (
            <Period
              startDate={startDate}
              endDate={endDate}
              onChange1={(date) => setStartDate(date)}
              onChange2={(date) => setEndDate(date)}
              selected={endDate}
              minDate={startDate}
              active={showPeriod}
              setActive={setShowPeriod}
            />
          )}

          <button
            className='p-3 max-w-[48px]  w-full rounded-[6px] flex bg-white items-center justify-center border border-[#EDEDED]'
            onClick={clearFilters}
          >
            <FilterAltOffOutlinedIcon color={"disabled"} />
          </button>
        </div>
        <div className='hidden sm:flex  gap-4 '>
          <DatePicker
            className='flex  max-w-[140px] sm:max-w-[200px]  w-full inputOutlined mr-4'
            dateFormat='dd-MM-yyyy'
            placeholderText='Период от'
            selected={startDate}
            selectsStart
            startDate={startDate}
            endDate={endDate}
            onChange={(date) => setStartDate(date)}
            // onChange={(date) => setDates((prev) => ({ ...prev, start: date }))}
          />
          <DatePicker
            className='flex max-w-[140px] sm:max-w-[200px]   w-full inputOutlined mr-4'
            dateFormat='dd-MM-yyyy'
            placeholderText='Период до'
            minDate={startDate}
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            selected={endDate}
            onChange={(date) => setEndDate(date)}
            // onChange={(date) => setDates((prev) => ({ ...prev, end: date }))}
          />

          <button
            className='p-3 max-w-[48px]  w-full rounded-[6px] flex bg-white items-center justify-center border border-[#EDEDED]'
            onClick={clearFilters}
          >
            <FilterAltOffOutlinedIcon color={"disabled"} />
          </button>
        </div>
        {/* <div className='flex justify-between items-center  px-4 mb-2'>
          <div className='flex items-center gap-4'>
            <div className='sm:flex items-center text-[18px] font-semibold text-[#737C86] hidden '>
              <span className='mr-2'>
                <img
                  src='/assets/balanceCoin.svg'
                  alt='coin'
                  className='min-w-12 min-h-12 w-full'
                />
              </span>
              Баланс:{" "}
              <span className='ml-1 font-bold text-[20px] text-[#1E3148]'>
                {balanceData?.balance || "0.00"}
              </span>
            </div>
            <button
              className='bg-[#EE6F42] hover:bg-[#ff7f3f] text-white whitespace-nowrap font-semibold px-5 py-2 rounded-[8px] transition-colors text-[15px]'
              onClick={handleOpenModal}
            >
              Пополнить баланс
            </button>
          </div>
        </div> */}
      </div>

      <div className='mt-6 bg-white  mx-4 sm:mx-[0] rounded-lg px-4 sm:px-0 h-full max-h-[100vh] min-h-[67vh]'>
        {transactionsData?.data?.length ? (
          <TransactionTable
            transactions={transactionsData?.data}
            setRowsPerPage={handleRowsPerPageChange}
            setCurrentPage={handlePageChange}
            currentPage={transactionsData?.meta?.current_page || 1}
            rowsPerPage={transactionsData?.meta?.per_page || 10}
            totalPages={transactionsData?.meta?.last_page || 1}
            totalItems={transactionsData?.meta?.total || 0}
          />
        ) : (
          <div className=' h-[60vh] flex justify-center items-center'>
            <EmptyState
              title={
                !startDate && !endDate && !search
                  ? "У вас пока нет транзакций"
                  : "Нет транзакций"
              }
              // description={
              //   !startDate && !endDate && !search
              //     ? "Когда вы пополните баланс или совершите первую операцию, здесь появится список ваших транзакций."
              //     : "За выбранный период не найдено ни одной транзакции."
              // }
              // action={
              //   <button
              //     className='bg-[#EE6F42] hover:bg-[#ff7f3f] text-white font-semibold px-5 py-2 rounded-[8px] transition-colors text-[15px]'
              //     onClick={handleOpenModal}
              //   >
              //     Пополнить баланс
              //   </button>
              // }
            />
          </div>
        )}
      </div>

      <BalanceModal
        open={isModalOpen}
        onClose={handleCloseModal}
        balanceData={balanceData}
      />
    </div>
  )
}

export default Transactions